import { document } from "browser-monads"

export const vwpx = vwValue => (
  document.body.clientWidth * vwValue / 100
)
